const faqData = [
   // simple paragraph answer (unchanged)
  {
    question: "What problem is NV solving?",
    answer: "Traditional art and jewelry marketplaces struggle with discovery, engagement, and trust. Creators have limited ways to showcase their work dynamically, and buyers often lack confidence in authenticity, pricing, and delivery. NV transforms art and jewelry sales into an entertainment-driven, social experience, where desire is built through video, storytelling, and competitive bidding — not static listings.",
  },

   {
    question: "What makes NV different from existing marketplaces?",
    answer: "Unlike traditional e-commerce or auction houses, NV is mobile-first and content-driven. Creators sell through short-form videos and rich media, while buyers engage through live bidding, instant purchases, and social interaction. This creates virality, emotional attachment, and higher conversion rates — similar to how TikTok revolutionized content discovery.",
  },

  {
    question: "Why focus on both art and jewelry?",
    answer: "Art and jewelry share high emotional value, scarcity, and storytelling potential. Jewelry introduces tangible luxury and recurring purchase behavior, while art brings cultural relevance and collector appeal. Together, they create a diversified yet complementary marketplace with strong upside across multiple buyer segments.",
  },

  {
    question: "Who are our target users?",
    answer: [
      {
        type: "ul",
        items: [
          "Creators: Independent artists, jewelry designers, luxury makers, and established brands looking for modern distribution",
          "Buyers: Collectors, luxury consumers, investors, and impulse buyers driven by entertainment and scarcity",
          "Partners: Galleries, authentication services, logistics providers, and payment infrastructure partners",
        ],
      },
    ],
  },

  // example with intro, bullets, outro (object)
  {
    question: "Why do we need investment and partnership?",
    answer: {
      intro: "We are seeking investment and strategic partnerships to accelerate growth and execution across several critical areas:",
      bullets: [
        "Complete and scale the mobile application, ensuring a stable, high-performance product with continuous feature development to stay competitive",
        "Build and maintain a strong, dedicated development team capable of rapid iteration and long-term innovation",
        "Develop an extremely secure payment infrastructure, supporting both traditional currency and crypto, designed with enterprise-grade security to be virtually unhackable",
        "Implement a robust authentication process for high-value art and jewelry, including verification of originality, provenance, precious stones, and carat details",
        "Create an end-to-end secure delivery system, ensuring that every item sold is fully tracked, insured, and protected from loss or theft",
      ],
      outro: "Investment enables us to move from a working prototype to a defensible, global platform.",
    },
  },

  {
    question: "How will NV generate revenue?",
    answer: "NV is designed with multiple scalable revenue streams that will grow alongside user engagement and transaction volume. These include marketplace transactions, premium tools and visibility for creators, and platform services tied to discovery, authentication, and secure fulfillment. As NV evolves, additional monetization layers can be introduced across commerce, content, and financial infrastructure—allowing flexibility while maintaining alignment between creators, buyers, and the platform.",
  },

  {
    question: "How do we address trust and security concerns?",
    answer: {
      intro: "Trust is foundational. We are building:",
      bullets: [
        "Multi-layer payment security and escrow-style transaction flows",
        "Identity verification for creators and sellers",
        "Authentication workflows for high-value items",
        "Secure logistics partnerships with tracking and insurance",
      ],
      outro: "This ensures buyer confidence and long-term platform credibility.",
    },
  },

  {
    question: "What stage is the company currently at?",
    answer: {
      intro: "The company has:",
      bullets: [
        "A clear product vision and business model",
        "A working prototype of the mobile application",
        "Ongoing platform development and feature expansion",
      ],
      outro: "We are now entering the scaling and validation phase, where capital and partnerships unlock rapid growth.",
    },
  },

  {
    question: "What is the long-term vision?",
    answer: "Our long-term vision is to become the go-to global marketplace for entertainment-driven luxury commerce, where art and jewelry are discovered, valued, and traded through culture, content, and competition — not static storefronts.",
  },

  // example using blocks array (flexible)
  {
    question: "What type of partners or investors are you looking for?",
    answer: [
      { type: "p", text: "We are looking for:" },
      {
        type: "ul",
        items: [
          "Strategic investors with experience in tech, marketplaces, fintech, or luxury",
          "Partners in payments, crypto infrastructure, authentication, and logistics",
          "Advisors who understand scaling consumer platforms and network effects",
        ],
      },
    ],
  },
];

export default faqData;